import { connect } from 'react-redux'
import Component from './Component'
import { getTBTSigning, submitTBTSignature } from '../../HttpRequests/tbtSignings'
import { message } from 'antd'

import {
  FETCH_RECORD_REQUEST,
  FETCH_RECORD_SUCCESS,
  FETCH_RECORD_FAILURE,
  FETCH_DOC_REQUEST,
  FETCH_DOC_SUCCESS,
  FETCH_DOC_FAILURE,
  SIGN_REQUEST,
  SIGN_SUCCESS,
  SIGN_FAILURE,
  RESET,
} from './reducer'

const mapStateToProps = (state) => ({
  record: state.screens.TBTSigningView.record,
  loading: state.screens.TBTSigningView.loading,
  error: state.screens.TBTSigningView.error,
  documentUrl: state.screens.TBTSigningView.documentUrl,
  documentType: state.screens.TBTSigningView.documentType,
  documentLoading: state.screens.TBTSigningView.documentLoading,
  signing: state.screens.TBTSigningView.signing,
  signed: state.screens.TBTSigningView.signed,
})

const componentDidMount = (id) => async (dispatch) => {
  dispatch({ type: RESET })
  dispatch({ type: FETCH_RECORD_REQUEST })

  try {
    const response = await getTBTSigning(id)
    const data = response.data

    // Build a record object matching what the component expects
    const record = {
      ...data.signed_record,
      toolbox_talk_document: data.document,
      subcontractor: data.subcontractor,
      toolbox_talk_run: data.signed_record.toolbox_talk_run,
      html_content: data.html_content,
      document_view_url: data.document_view_url,
      signed: data.already_signed,
      status: data.status,
    }

    dispatch({ type: FETCH_RECORD_SUCCESS, payload: record })

    // Fetch the document for inline viewing
    dispatch({ type: FETCH_DOC_REQUEST })
    try {
      if (data.document_view_url) {
        // document_view_url is an absolute path like /exports/teams/{slug}/tbt-signings/{id}/document
        // Use native fetch since this is NOT an API route (different prefix than /api/)
        const docResponse = await fetch(data.document_view_url, { credentials: 'same-origin' })
        const contentType = docResponse.headers.get('content-type') || ''

        if (contentType.includes('application/pdf')) {
          const blob = await docResponse.blob()
          const url = URL.createObjectURL(blob)
          dispatch({ type: FETCH_DOC_SUCCESS, payload: { url, type: 'pdf' } })
        } else {
          // HTML or other content — use the URL directly in an iframe
          dispatch({ type: FETCH_DOC_SUCCESS, payload: { url: data.document_view_url, type: 'html' } })
        }
      } else if (data.html_content) {
        // Create a blob URL from HTML content
        const blob = new Blob([data.html_content], { type: 'text/html' })
        const url = URL.createObjectURL(blob)
        dispatch({ type: FETCH_DOC_SUCCESS, payload: { url, type: 'html' } })
      } else {
        dispatch({ type: FETCH_DOC_FAILURE })
      }
    } catch (docError) {
      dispatch({ type: FETCH_DOC_FAILURE })
    }

  } catch (error) {
    const msg = error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : error.message
    dispatch({ type: FETCH_RECORD_FAILURE, payload: msg })
  }
}

const onSubmitSignature = (signatureData) => async (dispatch, getState) => {
  const record = getState().screens.TBTSigningView.record
  if (!record) return

  dispatch({ type: SIGN_REQUEST })
  try {
    const response = await submitTBTSignature(record.id, signatureData)
    dispatch({ type: SIGN_SUCCESS, payload: response.data })
    message.success('Tool Box Talk signed successfully!')
  } catch (error) {
    dispatch({ type: SIGN_FAILURE })
    const msg = error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : error.message
    message.error(msg)
  }
}

const mapDispatchToProps = {
  componentDidMount,
  onSubmitSignature,
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
